import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { stepControlsContextObj } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useApplicationContext } from '../ApplicationContext';
import { EEventType } from '../../types/eventEmitter';
import { HelpLinks } from '../../components/HelpLinks';
import { getFeedbackFormSettings } from '../../services/getFeedbackFormSettings';
import { jsx as _jsx } from "react/jsx-runtime";
export var HelpLinksContainer = function HelpLinksContainer() {
  var hidden = useSelector(function (state) {
    return state.helpLinks.hidden;
  });
  var context = useApplicationContext();
  var _React$useContext = React.useContext(stepControlsContextObj),
    isFirstStep = _React$useContext.isFirstStep;
  var _useApplicationContex = useApplicationContext(),
    emitter = _useApplicationContex.emitter;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    header = _React$useState4[0],
    setHeader = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    elements = _React$useState6[0],
    setElements = _React$useState6[1];
  var getFeedbackFormSettingsWrapped = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          setLoading(true);
          _context.next = 4;
          return getFeedbackFormSettings(context, {
            formId: 1
          });
        case 4:
          result = _context.sent;
          setHeader(result.model.header);
          setElements(result.model.elements);
          setLoading(false);
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          setLoading(false);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  })), [context]);
  React.useEffect(function () {
    if (!isFirstStep || hidden || loading || elements.length > 0) {
      return;
    }
    getFeedbackFormSettingsWrapped();
  }, [hidden, isFirstStep, getFeedbackFormSettingsWrapped]);
  if (!isFirstStep || hidden) {
    return null;
  }
  var handleFaqLinkClick = function handleFaqLinkClick(text) {
    emitter.emit(EEventType.FaqLinkClicked, {
      text: text
    });
  };
  var handleHelpCenterLinkClick = function handleHelpCenterLinkClick() {
    emitter.emit(EEventType.HelpCenterLinkClicked);
  };
  return /*#__PURE__*/_jsx(HelpLinks, {
    isLoading: loading,
    header: header,
    elements: elements,
    onFaqLinkClick: handleFaqLinkClick,
    onHelpCenterLinkClick: handleHelpCenterLinkClick
  });
};